import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import resetApiMiddleware from './middelware/resetApiState';

// reducers
import workbookReducer from "./workbook/workbookSlice";
import loaderReducer from "./loader/loaderSlice";
import authReducer from "./auth";
import userReducer from "./user/userSlice";

// services
import { astrologyApi } from "./services/astrology.service";
import { userService } from "./services/user.service";
import { workbookService } from "./services/workbook.service";

const persistConfig = {
  key: "auth",
  storage,
};

const rootReducer = combineReducers({
  workbook: workbookReducer,
  loader: loaderReducer,
  auth: persistReducer(persistConfig, authReducer),
  user: userReducer,
  [astrologyApi.reducerPath]: astrologyApi.reducer,
  [userService.reducerPath]: userService.reducer,
  [workbookService.reducerPath]: workbookService.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      astrologyApi.middleware,
      userService.middleware,
      workbookService.middleware,
      resetApiMiddleware
    ),
});

export const persistor = persistStore(store);

setupListeners(store.dispatch);
